export default __webpack_public_path__ + "static/media/olb-default.45bd5523.jpg";